import { gql } from '@apollo/client'
import { FileFragment } from './file.fragment'

export const ProjectEmailSettingsFragment = gql`
  fragment ProjectEmailSettingsFragment on ProjectEmailSettings {
    id
    subjectPrefix
    file {
      ...FileFragment
    }
  }
  ${FileFragment}
`
